import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class CrmTaskService extends Service {
	constructor(injector: Injector) {
		super("CrmTask", injector);
	}

	getByOpportunityId(opportunityId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetByOpportunityId/${opportunityId}`);
	}

	getMyTasks() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetMyTasks`);
	}

	getTasksForUser(userProfileId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetTasksForUser/${userProfileId}`);
	}
}
